<script setup>
import {ref, onBeforeMount} from "vue"
import {refundStateEnum} from "@/enum/refundStateEnum.js"
const props = defineProps({
  state: {
    required: true,
    type: String,
    default: "NONE"
  }
})

// 执行订单判断
onBeforeMount(() => {
  handleEnum()
})

// 展示的文本类型
const textType = ref("info")
// 状态名称
const stateName = ref("未知状态")
// 订单状态枚举
const refundState = refundStateEnum

// 根据枚举返回订单状态
const handleEnum = () => {
  try {
    const refund = refundState.find(res => res.stateId === props.state)
    stateName.value = refund.stateName ? refund.stateName : "未知状态"
    switch (props.state) {
      case "NONE":
        textType.value = "primary"
        break
      case "REQUESTED":
        textType.value = "primary"
        break
      case "APPROVED":
        textType.value = "success"
        break
      case "REJECTED":
        textType.value = "danger"
        break
      case "PROCESSING":
        textType.value = "warning"
        break
      case "SUCCESS":
        textType.value = "success"
        break
      case "ABNORMAL":
        textType.value = "danger"
        break
    }
  } catch (e) {
    console.log(e)
  }
}
</script>

<template>
  <el-text :type="textType" v-text="stateName"></el-text>
</template>

<style scoped>

</style>